<template>
    <div
        class="field-number field-wrap"
        v-bind:class="{
            'field-number--has-focus': hasFocus,
            'field-number--has-content':
                simpleFieldGet === '0' || simpleFieldGet === 0 || simpleFieldGet > 0
        }"
    >
        <label v-if="label || required" class="field-number__label">
            {{ label }}<span v-if="required" class="field-number__label-required">&nbsp;*</span>
        </label>

        <div class="field-number__input-wrap">
            <input
                v-model="simpleFieldModel"
                @focus="hasFocus = true"
                @blur="hasFocus = false"
                type="number"
                :min="min"
                :max="max"
                :disabled="checkDisabled"
                :required="required"
                class="field-number__input"
            />
        </div>
        <button
            :disabled="increaseButtonDisabled"
            v-on:click.prevent="inc"
            href="#"
            class="field-number__button field-number__button--plus"
        >
            +
        </button>
        <button
            :disabled="decreaseButtonDisabled"
            v-on:click.prevent="dec"
            href="#"
            class="field-number__button field-number__button--minus"
        >
            -
        </button>
    </div>
</template>

<script>
import { SimpleFieldMixin } from '@/mixins/SimpleFieldMixin';

export default {
    data() {
        return {
            hasFocus: false
        };
    },
    components: {},
    computed: {
        increaseButtonDisabled() {
            let value = this.simpleFieldGet;
            if (value === undefined || value === null || value === '') {
                return false;
            }
            return this.simpleFieldGet >= this.max;
        },
        decreaseButtonDisabled() {
            let value = this.simpleFieldGet;
            if (value === undefined || value === null || value === '') {
                return false;
            }
            return this.simpleFieldGet <= this.min;
        }
    },
    methods: {
        inc() {
            this.add(1);
        },
        dec() {
            this.add(-1);
        },
        add(i) {
            let value = this.simpleFieldGet;
            if (value !== undefined && value !== null && value !== '') {
                value = parseInt(value) + i;
            } else {
                value = this.min;
            }
            this.simpleFieldSet(value);
        }
    },
    mixins: [SimpleFieldMixin],
    props: {
        min: Number,
        max: Number
    }
};
</script>
